import React from 'react';

const Marquee = ({ items }) => {
  const track = (
    <div className="marquee-track" aria-hidden="true">
      {items.map((item, i) => (
        <React.Fragment key={`${item}-${i}`}>
          <span className="marquee-item" dangerouslySetInnerHTML={{ __html: item }} />
          <span className="marquee-sep">◆</span>
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <div className="marquee" role="presentation">
      {track}
      {track}
    </div>
  );
};

export default Marquee;
